export default "__VITE_ASSET__C9Y6pP7N__"